import { HttpClient } from '@angular/common/http';
import { Directive, EventEmitter, Injectable, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Directive()
@Injectable()
export class HeaderServiceDirective {

  public currentSection: string;
  public currentChildSection: string;
  @Output() maxNumberOfAutomatedRulesExceeded: EventEmitter<boolean> = new EventEmitter();
  @Output() changeCurrentSection: EventEmitter<string> = new EventEmitter();
  @Output() changeCurrentChildSection: EventEmitter<string> = new EventEmitter();

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
      )
      .subscribe(e => {
        if (route.root.firstChild.children.length > 0) {
          if (route.root.firstChild.children[0].snapshot.data.hasOwnProperty('title')) {
            this.currentChildSection = route.root.firstChild.children[0].snapshot.data.title;
            this.changeCurrentChildSection.emit(this.currentChildSection);
          } else {
            this.currentChildSection = '';
            this.changeCurrentChildSection.emit(this.currentChildSection);
          }
        } else {
          this.currentChildSection = '';
          this.changeCurrentChildSection.emit(this.currentChildSection);
        }
        this.currentSection = route.root.firstChild.snapshot.data.title;
        this.changeCurrentSection.emit(this.currentSection);
      });
  }
}
